import React, { memo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

// Renders assistant text as GitHub-flavored Markdown (bold, headings, lists,
// tables, code). User messages stay plain to avoid surprising formatting.
export const MarkdownMessage = memo(function MarkdownMessage({ content, isUser }) {
  if (isUser) {
    return <div className="whitespace-pre-wrap">{content}</div>;
  }
  return (
    <div className="md-content" data-testid="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          table: ({ node, ...props }) => (
            <div className="md-table-wrap">
              <table {...props} />
            </div>
          ),
          code: ({ node, inline, className, children, ...props }) =>
            inline ? (
              <code className="md-code-inline" {...props}>{children}</code>
            ) : (
              <pre className="md-code-block">
                <code className={className} {...props}>{children}</code>
              </pre>
            ),
          a: ({ node, ...props }) => (
            <a target="_blank" rel="noreferrer" {...props} />
          ),
        }}
      >
        {content || ""}
      </ReactMarkdown>
    </div>
  );
});

export default MarkdownMessage;
